import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse, DashboardMetricResponse } from '../models/models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private readonly apiUrl = `${environment.apiUrl}/dashboard`;

  constructor(private http: HttpClient) {}

  getDashboardMetrics(): Observable<ApiResponse<DashboardMetricResponse>> {
    return this.http.get<ApiResponse<DashboardMetricResponse>>(`${this.apiUrl}/count-institution`);
  }
}
